module.exports = __webpack_public_path__ + "img/login_carousel.cae617de.webp";